import * as angular from "angular";
import {ApiUrl} from "../../models/app-config.model";
import {StaffImportStatus, StaffImportPostOptions} from "../../models/staff-import-status.model";

export interface StaffImportRecordsService {
    getStaffImportStatus: (districtId: string) => angular.IPromise<StaffImportStatus>;
    staffImport: (options: StaffImportPostOptions) => angular.IPromise<number>;
}

/* @ngInject */
export function staffImportRecordsService($http: angular.IHttpService, API_URL: ApiUrl, $q: angular.IQService): StaffImportRecordsService {
    let handleErrorResponse = (errorResponse): any => {
        return errorResponse && errorResponse.status === 404 ? [] : $q.reject(errorResponse) ;
    };

    return {
        getStaffImportStatus: (districtId: string): angular.IPromise<StaffImportStatus> => {
            return $http.get(`${API_URL.staffImportStatus.replace(/\:districtId/, districtId)}`)
                .then((response: {data: StaffImportStatus}) => {
                    return response.data;
                }, handleErrorResponse);
        },
        staffImport: (options: StaffImportPostOptions): angular.IPromise<number> => {
            return $http.post(`${API_URL.staffImport}`, options)
                .then((response: {status: number}) => {
                    return response.status;
                }, handleErrorResponse);
        }
    };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/services/staff-import-records/staff-import-records.service.ts